import { render, staticRenderFns } from "./VehicleManangeEventBox.vue?vue&type=template&id=147463ea&scoped=true&"
import script from "./VehicleManangeEventBox.vue?vue&type=script&lang=js&"
export * from "./VehicleManangeEventBox.vue?vue&type=script&lang=js&"
import style0 from "./VehicleManangeEventBox.vue?vue&type=style&index=0&id=147463ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147463ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
